import LegalPage from "@/components/LegalPage";

const CONTENT = {
  en: {
    overline: "Legal — Terms",
    title: "Terms of Use",
    intro:
      "These terms govern the use of this website, operated by GADULABS YAZILIM LİMİTED ŞİRKETİ (\u201CGADULABS\u201D).",
    chapters: [
      {
        title: "Scope",
        text: "This website presents information about GADULABS and its software products and projects, including Cernio, DOSE Modernization and KampanyamBenim.",
      },
      {
        title: "Informational content",
        text: "Product and project descriptions on this site are general information. They do not constitute a binding offer, quotation, or a guarantee of features, availability or launch dates.",
      },
      {
        title: "Intellectual property",
        text: "Content created by GADULABS belongs to GADULABS YAZILIM LİMİTED ŞİRKETİ. Referenced brands, website screenshots and third-party images remain the property of their respective owners. Reuse is subject to the rights holder’s permission.",
      },
      {
        title: "External links",
        text: "This site may contain links to third-party websites. GADULABS is not responsible for their content or availability.",
      },
      {
        title: "Liability",
        text: "This website is provided as is. To the extent permitted by applicable law, GADULABS accepts no liability for damages arising from the use of this website.",
      },
      {
        title: "Governing law",
        text: "These terms are governed by the laws of the Republic of Türkiye. The courts of Yalova, Türkiye have jurisdiction over any disputes.",
      },
      {
        title: "Contact",
        text: "Questions about these terms can be sent to info@gadulabs.com.",
      },
    ],
    footnote: "GADULABS YAZILIM LİMİTED ŞİRKETİ — Yalova, Türkiye",
  },
  tr: {
    overline: "Yasal — Koşullar",
    title: "Kullanım Koşulları",
    intro:
      "Bu koşullar, GADULABS YAZILIM LİMİTED ŞİRKETİ (\u201CGADULABS\u201D) tarafından işletilen bu web sitesinin kullanımını düzenler.",
    chapters: [
      {
        title: "Kapsam",
        text: "Bu web sitesi; GADULABS ve Cernio, DOSE Modernization ve KampanyamBenim dâhil yazılım ürün ve projeleri hakkında bilgi sunar.",
      },
      {
        title: "Bilgilendirme amaçlı içerik",
        text: "Bu sitedeki ürün ve proje açıklamaları genel bilgilendirmedir. Bağlayıcı bir teklif, fiyat teklifi veya özellik, kullanılabilirlik ya da lansman tarihi garantisi oluşturmaz.",
      },
      {
        title: "Fikri mülkiyet",
        text: "GADULABS tarafından üretilen içerikler GADULABS YAZILIM LİMİTED ŞİRKETİ’ne aittir. Atıf yapılan markalar, web sitesi görüntüleri ve üçüncü taraf görselleri ilgili hak sahiplerine aittir. Yeniden kullanım, hak sahibinin iznine tabidir.",
      },
      {
        title: "Dış bağlantılar",
        text: "Bu site üçüncü taraf web sitelerine bağlantılar içerebilir. GADULABS, bu sitelerin içeriğinden veya erişilebilirliğinden sorumlu değildir.",
      },
      {
        title: "Sorumluluk",
        text: "Bu web sitesi olduğu gibi sunulur. Yürürlükteki yasaların izin verdiği ölçüde GADULABS, bu web sitesinin kullanımından doğan zararlara ilişkin sorumluluk kabul etmez.",
      },
      {
        title: "Uygulanacak hukuk",
        text: "Bu koşullar Türkiye Cumhuriyeti yasalarına tabidir. Uyuşmazlıklarda Yalova mahkemeleri yetkilidir.",
      },
      {
        title: "İletişim",
        text: "Bu koşullarla ilgili sorularınızı info@gadulabs.com adresine gönderebilirsiniz.",
      },
    ],
    footnote: "GADULABS YAZILIM LİMİTED ŞİRKETİ — Yalova, Türkiye",
  },
};

export default function TermsPage() {
  return <LegalPage content={CONTENT} testid="terms" />;
}
